<script lang="ts">
  export let href: string;
  export let rel: string | undefined = undefined;
</script>

<a {rel} class="text-c-green-100 hover:underline" {href}><slot /></a>
